module.exports = __webpack_public_path__ + "static/assets/2a3ba1084cca0bc13b8879eeb87c7640.png";